function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m16.507857 63.621659c-3.308208 1.188683-6.9555307-.516195-8.1653277-3.816736-1.2098056-3.300546.471729-6.958689 3.7644687-8.189559l35.348647-12.959291c3.310915-1.214808 6.984345.486569 8.200764 3.802315 1.21737 3.315315-.485665 6.989462-3.802324 8.203174zm0-19.132414c-3.308208 1.188681-6.9555307-.516197-8.1653277-3.816736-1.2098056-3.300548.471729-6.958689 3.7644687-8.189559l35.348647-12.958481c3.310915-1.216419 6.984345.486567 8.200764 3.802311 1.216733 3.314643-.486308 6.987738-3.802324 8.200757zm0-19.132414c-3.296012 1.146333-6.9023787-.561866-8.1035087-3.8383-1.2011208-3.276438.446692-6.910791 3.7026497-8.166381l35.348647-12.9592916c3.310915-1.216418 6.984345.486567 8.200764 3.802316 1.216733 3.314648-.486308 6.9877396-3.802324 8.2007586z",
  strokeWidth: 0.805575
});

var SvgEricsson = function SvgEricsson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1.5rem",
    viewBox: "0 0 64 63.999998",
    width: "1.5rem",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEricsson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ericsson.ae74eb8f.svg";
export { ForwardRef as ReactComponent };